import React, { Component } from 'react';
import Modal from 'react-bootstrap/Modal';
import InnerReferences from '../../containers/StatModelMoreInfo/InnerReferences';
import './ReferencesModal.css';

class ReferencesModal extends Component {
    render() {
        const { show, onHide } = this.props;
        
        return (
            <Modal 
                show={show} 
                onHide={onHide}
                aria-labelledby="references-modal-title"
                size='lg'
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="references-modal-title">
                        References
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InnerReferences />
                </Modal.Body>
            </Modal>
        );
    }
}

export default ReferencesModal;
